import { gql } from '@apollo/client';

export const CREATE_MEMBERSHIP = gql`
mutation createMembership($input: MembershipInput) {
  createMembership(input: $input) {
    membership {
      id
      status
      publisherInvitation {
        id
      }
    }
  }
}
`;
